export default __webpack_public_path__ + "static/media/error.1ef487b0.png";